import React from "react";
import { Dropdown } from "react-bootstrap";
import { gettext } from "../../../shared/utils/legacy";
import cropr from "../../../shared/utils/cropr";
import { ImgA } from "../../../shared/components/Img";
import NutrientDropdown from "../../../shared/dropdowns/NutrientDropdown";

interface User {
  avatar: string;
  name: string;
  attachmentKey: string;
}

const NavBarAvatar = ({ user }: { user: User }) => {
  return (
    <Dropdown
      className={"c-navbar__nav-item c-navbar__nav-item-avatar"}
      as={"li"}
      alignRight={true}
    >
      <Dropdown.Toggle as={"a"} bsPrefix={"dropdown-toggle"}>
        <ImgA
          src={
            user.attachmentKey
              ? cropr.getImageUrl(user.attachmentKey, { resize: true, width: 40, height: 40 })
              : user.avatar
          }
          alt={user.name}
        />
      </Dropdown.Toggle>
      <NutrientDropdown.Menu>
        <NutrientDropdown.Header title={gettext("Settings")} />
        <NutrientDropdown.Item icon={"user"} href={"/cropr/settings/profile/"}>
          {gettext("My account")} / {gettext("Language")}
        </NutrientDropdown.Item>
        <NutrientDropdown.Item icon={"farm"} href={"/cropr/settings/farm/"}>
          {gettext("My farm")}
        </NutrientDropdown.Item>
        <NutrientDropdown.Header title={gettext("Support")} />
        <NutrientDropdown.Item icon={"question circle"} href={"/cropr/settings/manuals"}>
          {gettext("Manuals")}
        </NutrientDropdown.Item>
        <NutrientDropdown.Item
          icon={"information circle"}
          href={"https://get.teamviewer.com/dacom_support"}
        >
          {gettext("Teamviewer")}
        </NutrientDropdown.Item>
        <NutrientDropdown.Item icon={"mail"} href={"mailto:service@dacom.nl"}>
          {gettext("Mail")}
        </NutrientDropdown.Item>
        <NutrientDropdown.Button href={"/subscription/my_subscriptions"}>
          {gettext("My subscription")}
        </NutrientDropdown.Button>
        <NutrientDropdown.Button href={"/accounts/logout"} variant={"smoke"}>
          {gettext("Log out")}
        </NutrientDropdown.Button>
      </NutrientDropdown.Menu>
    </Dropdown>
  );
};

export default NavBarAvatar;
